import type { ClientPathsWithMethod } from 'openapi-fetch';

import { client } from './index';

// import { useQueryClient } from '@tanstack/react-query';

// import { api } from './index';

export function createPatcher(
    url: ClientPathsWithMethod<typeof client, 'patch'>,
    patcherObject: Record<string, unknown>,
    options: { onSettled?: () => void; onSuccess?: () => void; onError?: (error: unknown) => void } = {},
) {
    return (
        fieldName: string,
        valueManipulationFunction?: (value: unknown) => unknown,
    ) =>
        async ({ value }: { value: unknown }) => {
            try {
                value = valueManipulationFunction
                    ? valueManipulationFunction(value)
                    : value;

                const body: any = { ...patcherObject }; // HACK: Dit is echt zo tering triest, maar ik kan niet anders - Copilot 11-02-2025

                if (fieldName.includes('.')) {
                    const keys = fieldName.split('.');
                    const clearfields: string[] = [];
                    keys.reduce((acc, key, index) => {
                        // HACK: Dit is echt zo tering triest, maar ik kan niet anders - Copilot 05-02-2025
                        if (
                            fieldName.includes('clearfields')
                            && key !== 'clearfields'
                        ) {
                            clearfields.push(key);
                        }
                        else if (index === keys.length - 1) {
                            acc[key] = value;
                        }
                        else {
                            acc[key] = acc[key] || {};
                        }
                        return acc[key] as Record<string, unknown>;
                    }, body);

                    if (fieldName.includes('clearfields')) {
                        body.clearfields = clearfields;
                    }
                }
                else {
                    body[fieldName] = value;
                }

                const response = await client.PATCH(url, {
                    body,
                });

                if (!response.error) {
                    if (options.onSuccess)
                        options.onSuccess();
                    return undefined;
                }

                if (!('ModelState' in response.error)) {
                    if (options.onError)
                        options.onError(response.error);
                    return undefined;
                }

                const modelState = response.error.ModelState;

                if (!modelState) {
                    if (options.onError)
                        options.onError(response.error);
                    return undefined;
                }

                if (modelState[`command.${fieldName}`]) {
                    const errorMessage = modelState[`command.${fieldName}`][0];
                    if (options.onError)
                        options.onError(errorMessage);
                    return errorMessage;
                }

                if (options.onError)
                    options.onError(response.error);
                return undefined;
            }
            catch (error) {
                if (options.onError)
                    options.onError(error);
                return undefined;
            }
            finally {
                if (options.onSettled)
                    options.onSettled();
            }
        };
}

export const debounceTime = 500;
